import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";


interface FullFinalSettlementLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  amount: string;
  bank_number: string;
}

const FullFinalSettlementLetter = ({ refNo, date, name, address, amount, bank_number }: FullFinalSettlementLetterProps) => (
  <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Full and Final Settlement Letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
        As of <b>{date}</b>, you are relieved from all your duties and responsibilities with the Company. 
        Your full and final settlement has been prepared in accordance with the terms and conditions mentioned in your appointment letter.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      An amount of <b>{amount}</b> has been processed towards your full and final settlement and will becredited to your bank account number <b>{bank_number}</b>.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    With this payment, all financial dues between you and the Company stand settled, and no further claims will be entertained in this regard.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
     You are requested to kindly acknowledge your acceptance of this settlement by signing and returning a copy of this letter.   
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      We thank you for your association with the Company and wish you success in your future endeavors.  
    </p>

    <Signature />
  </div>
);

export default FullFinalSettlementLetter;
